<app-dialog></app-dialog>

<div class="layout-topbar">

    <!-- Izquierda: logo + título de pantalla + breadcrumb -->
    <div class="page-header">
        <div class="brand-block"
             [class.brand-block--static]="!isLogoClickable"
             (click)="isLogoClickable && backToSection()"
             (keydown.enter)="isLogoClickable && backToSection()"
             [attr.tabindex]="isLogoClickable ? 0 : null"
             [attr.role]="isLogoClickable ? 'button' : null"
             [attr.aria-label]="isLogoClickable ? 'Ir a selección de sistemas' : null">
            <img src="assets/images/oldelval-go-logo.png" alt="Logo Oldelval" class="topbar-logo" />
        </div>
    </div>

    <!-- Derecha: badge + búsqueda + notificaciones + perfil -->
    <div class="nav-right">

        <div class="env-badge" *ngIf="showEnvBadge">
            <span>{{ envName | uppercase }}</span>
        </div>

        <div class="search-wrapper" (click)="$event.stopPropagation()">
            <div class="search-box">
                <input
                    type="text"
                    placeholder="Buscar..."
                    [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearchChange($event)"
                    (focus)="onSearchFocus()"
                    aria-label="Buscar en el sistema"
                    role="combobox"
                    autocomplete="off"
                    [attr.aria-expanded]="searchDropdownOpen"
                    aria-controls="nav-search-results"
                    aria-haspopup="listbox"
                />
                <button *ngIf="searchQuery" type="button" class="clear" (click)="clearSearch()" aria-label="Limpiar búsqueda">
                    <span class="pi pi-times"></span>
                </button>
                <span class="pi pi-search" aria-hidden="true"></span>
            </div>

            @if (searchDropdownOpen) {
                <div id="nav-search-results" class="search-dropdown" role="listbox" aria-label="Resultados de búsqueda">

                    @if (searchResults.length > 0) {
                        <div class="search-dropdown-header">
                            {{ searchResults.length }} RESULTADO{{ searchResults.length !== 1 ? 'S' : '' }}
                        </div>
                        @for (result of searchResults; track result.routerLink[0]) {
                            <button type="button"
                                    class="search-result-item"
                                    (mousedown)="navigateToSearchResult(result)"
                                    role="option">
                                <div class="search-result-icon-box">
                                    <span [class]="result.icon || 'pi pi-circle'" aria-hidden="true"></span>
                                </div>
                                <div class="search-result-info">
                                    <span class="search-result-label">{{ result.label }}</span>
                                    <span class="search-result-section">{{ result.section | uppercase }}</span>
                                </div>
                                <span class="pi pi-arrow-right search-result-arrow" aria-hidden="true"></span>
                            </button>
                        }
                    } @else {
                        <div class="search-empty">
                            <span class="pi pi-search search-empty-icon" aria-hidden="true"></span>
                            <span>Sin resultados para <strong>"{{ searchQuery }}"</strong></span>
                        </div>
                    }

                </div>
            }
        </div>

<!--         <div class="ai-chat-wrapper" (click)="$event.stopPropagation()">
            <button type="button"
                    class="nav-icon-btn"
                    [class.active]="aiChatOpen"
                    (click)="toggleAiChat()"
                    aria-label="Asistente IA"
                    [attr.aria-expanded]="aiChatOpen">
                <span class="pi pi-comments"></span>
            </button>
            @if (aiChatOpen) {
                <app-ai-chat-panel></app-ai-chat-panel>
            }
        </div> -->

        <div class="notif-wrapper" (click)="$event.stopPropagation()">
            <button
                type="button"
                class="nav-icon-btn"
                [class.active]="notifOpen"
                (click)="toggleNotif()"
                aria-label="Notificaciones"
                [attr.aria-expanded]="notifOpen"
                aria-haspopup="true">
                <span class="pi pi-bell"></span>
                @if (unreadNotifCount > 0) {
                    <span class="notif-badge" [attr.aria-label]="unreadNotifCount + ' notificaciones sin leer'"></span>
                }
            </button>

            @if (notifOpen) {
                <div class="notif-panel" role="dialog" aria-label="Panel de notificaciones">

                    <div class="notif-panel-header">
                        <span class="notif-panel-title">Notificaciones</span>
                        @if (unreadNotifCount > 0) {
                            <button
                                type="button"
                                class="notif-panel-unread"
                                (click)="markAllNotificationsRead($event)">
                                Marcar {{ unreadNotifCount }} como leída{{ unreadNotifCount === 1 ? '' : 's' }}
                            </button>
                        }
                    </div>

                    <div class="notif-panel-body">
                        @if (notificationsStore.loading() && !notificationsStore.loaded()) {
                            <div class="notif-panel-empty" role="status">Cargando notificaciones…</div>
                        } @else if (notificationsStore.error()) {
                            <div class="notif-panel-empty notif-panel-empty--error" role="alert">
                                {{ notificationsStore.error() }}
                            </div>
                        } @else if (previewNotifications.length === 0) {
                            <div class="notif-panel-empty" role="status">No tenés notificaciones sin leer.</div>
                        } @else {
                            @for (notification of previewNotifications; track notification.id) {
                                <button
                                    type="button"
                                    class="notif-item notif-item--unread"
                                    (click)="openNotification(notification)"
                                    [attr.aria-label]="notification.title">
                                    <span
                                        class="notif-item-dot notif-item-dot--{{ notificationSeverity(notification) }}"
                                        aria-hidden="true"></span>
                                    <div class="notif-item-content">
                                        <p class="notif-item-titulo">{{ notification.title }}</p>
                                        <span class="notif-item-meta">
                                            {{ relativeNotificationTime(notification.createdAt) }} ·
                                            {{ notificationKindLabel(notification.kind) }}
                                        </span>
                                    </div>
                                </button>
                            }
                        }
                    </div>

                    <button type="button" class="notif-panel-footer" (click)="goNotificaciones()">
                        Ver todas
                    </button>

                </div>
            }
        </div>

        <div class="nav-divider" aria-hidden="true"></div>

        <div class="profile"
             (click)="$event.stopPropagation(); toggleProfile()"
             tabindex="0"
             role="button"
             [attr.aria-expanded]="profileOpen"
             aria-haspopup="true"
             [attr.aria-label]="'Menú de ' + (user?.nombre || 'Usuario')">
            <div class="user-avatar" aria-hidden="true">{{ avatarLetters }}</div>
            <span class="name">{{ user?.nombre }} {{ user?.apellido }}</span>
            <span class="pi pi-chevron-down expand-icon" [class.rotated]="profileOpen" aria-hidden="true"></span>

            <div class="dropdown" *ngIf="profileOpen" (click)="$event.stopPropagation()" role="menu">
                <button type="button" (click)="goPerfil()" role="menuitem">
                    <span class="pi pi-user"></span> Mi Perfil
                </button>
                <button type="button" role="menuitem">
                    <span class="pi pi-sliders-h"></span> Preferencias
                </button>
                <button type="button" (click)="backToSection()" role="menuitem">
                    <span class="pi pi-th-large"></span> Selección de sistema
                </button>
                <button type="button" *ngIf="isImpersonating" (click)="stopImpersonation()" role="menuitem">
                    <span class="pi pi-undo"></span> Salir vista usuario
                </button>
                <div class="dropdown-sep" aria-hidden="true"></div>
                <button type="button" (click)="logout()" class="danger" role="menuitem">
                    <span class="pi pi-sign-out"></span> Cerrar Sesión
                </button>
            </div>
        </div>

    </div>

    <!-- Banners: segunda fila (colapsa cuando no hay contenido) -->
    <div class="topbar-banners">
        <app-pre-maintenance-banner position="relative" customMessage="⚠️ Mantenimiento programado en {time}"></app-pre-maintenance-banner>
        <div class="impersonation-banner" *ngIf="isImpersonating">
            <i class="pi pi-eye impersonation-icon"></i>
            <span class="impersonation-title">MODO AUDITORÍA</span>
            <span class="impersonation-separator">|</span>
            <span class="impersonation-text">
                por {{ auditedByName }} · viendo como <strong>{{ targetName }}</strong> · solo acceso de vista
            </span>
        </div>
    </div>

</div>
